<template>
  <LoginForm mode="reset" :response="message" v-on:form-submitted="resetPassword">
  </LoginForm>
</template>

<script>
import LoginForm from '@/components/LoginForm.vue';

export default {
  name: 'NewPassword',
  components: { LoginForm },
  data: () => ({
    message: {
      content: '',
      color: 'black',
    },
  }),
  methods: {
    resetPassword(data) {
      const postData = { auth_token: this.$route.query.auth_token, ...data };
      const url = 'https://portal.beyondlabz.com/auth/verified/update';
      this.$http.post(url, postData)
        .then((resp) => {
          console.log('NewPassword :: resetPassword :: ', resp);
          if (resp.status === 200) {
            if (resp.data.loggedIn) {
              this.message.content = 'Successfully changed password.';
              this.$store.commit('SET_USER', resp.data);
              this.$router.push('/');
            } else {
              this.message.content = 'Failed to change password. Please try again or contact support@beyondlabz.com.';
              this.message.color = 'red';
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.message.content = 'Failed to change password. Please try again or contact support@beyondlabz.com.';
          this.message.color = 'red';
        });
    },
  },
};
</script>

<style scoped>

</style>
